export class PlanPhaseItem {
  _id: string;
  planphase: string;
  budget: number;
  work: number
}